<div kalDialogClose></div>

<div kalDialogHeader>
    <h2>Impression de la lettre chèque</h2>
</div>

<div kalDialogContent [formGroup]="form" [kalLoading]="loading">
    <kal-select formControlName="Id"
                label="Modèle de lettre chêque">
        <kal-option *ngFor="let letter of lettersList"
                    [value]="letter.Id">
            {{letter.Libelle}}
        </kal-option>
    </kal-select>

    <kal-form-field class="without-label">

        <kal-checkbox kalTheme="switch"
                      formControlName="IsLogoVisible"
                      label="Afficher le logo du CSE">
        </kal-checkbox>

        <p class="small gup-U-color--400">Le logo affiché est celui téléchargé sur la page Infos CSE dans le menu Administration</p>

    </kal-form-field>

    <kal-form-field class="without-label">

        <kal-checkbox kalTheme="switch"
                      formControlName="IsAdresseCEVisible"
                      label="Afficher les coordonnées du CSE">
        </kal-checkbox>

        <p class="small gup-U-color--400">Les coordonnées affichées sont celles qui sont renseignées sur la page Infos CSE dans le menu
            Administration </p>

    </kal-form-field>

    <kal-form-field class="gup-C-formFieldSize--select">

        <kal-select label="Modèle d'adresse"
                    formControlName="ModeleAdresse"
                    disableFirstOptionSelection
                    placeholder="Sélectionner un modèle d'adresse">
            <kal-option *ngFor="let addressModel of addressModelsList"
                        [value]="addressModel">
                {{ addressModel.LibelleModeleAdresse }}
            </kal-option>

        </kal-select>

    </kal-form-field>

    <!-- Objet -->
    <kal-form-field>

        <kal-input
            formControlName="Objet"
            label="Objet"></kal-input>

    </kal-form-field>

    <!-- Contenu -->
    <kal-form-field class="editorLabel">

        <ng-template kalFormFieldLabel>

            <div>Contenu <span class="gup-U-color--orange">*</span></div>

        </ng-template>

        <editor
            (onChange)="updateFormValueAndValidity()"
            (onKeyUp)="updateFormValueAndValidity()"
            [init]="editorConfig"
            formControlName="Corps">
        </editor>

    </kal-form-field>

    <kal-form-field>

        <kal-input formControlName="SignatureCE"
                   label="Signature">
        </kal-input>

    </kal-form-field>

    <kal-form-field>

        <kal-input formControlName="BasDePage"
                   label="Bas de page">
        </kal-input>

    </kal-form-field>

    <kal-form-field>

        <kal-input formControlName="PiedDePage"
                   label="Pied de page">
        </kal-input>

    </kal-form-field>
</div>

<div kalDialogFooter>
    <kal-button kalTheme="primary"
                [disabled]="form.invalid || loading"
                (click)="saveModel()">
        Valider
    </kal-button>
    <kal-button kalTheme="secondary"
                (click)="close()">
        Annuler
    </kal-button>
</div>
